import { render, staticRenderFns } from "./LegalOwnerInput.vue?vue&type=template&id=5ccd32b1&scoped=true"
import script from "./LegalOwnerInput.vue?vue&type=script&lang=js"
export * from "./LegalOwnerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd32b1",
  null
  
)

export default component.exports